export interface ConversationPage<TItem> {
  items: TItem[];
  nextOffset?: number | null;
}

export interface UsePaginatedConversationsArgs<TItem> {
  endpoint: string;
  debouncedQuery?: string;
  extraParams?: Record<string, string>;
  pageSize?: number;
  enabled: boolean;
  parsePage: (data: unknown) => ConversationPage<TItem>;
}

export interface UsePaginatedConversationsResult<TItem> {
  items: TItem[];
  isLoadingInitial: boolean;
  isLoadingMore: boolean;
  hasMore: boolean;
  hasError: boolean;
  loadMore: () => void;
  isSearchMode: boolean;
  reload: () => void;
}

export function buildConversationPageUrl(
  endpoint: string,
  query: string,
  extraParams: Record<string, string> | undefined,
  pageSize: number,
  offset: number,
): string {
  const search = new URLSearchParams({
    ...extraParams,
    limit: String(pageSize),
    offset: String(offset),
  });
  if (query) search.set("q", query);
  return `${endpoint}?${search.toString()}`;
}
